import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import UpperCaseInput from '../../../components/UpperCaseInput';
import { CORREDOR_OPTIONS } from '../utils/constants';

const CreateDispatchModal = ({
  isOpen,
  onClose,
  formData,
  setFormData,
  importadoras,
  dispatchNumberError,
  validateDispatchNumber,
  onSubmit
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader><DialogTitle>Crear Despacho</DialogTitle></DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2 col-span-2">
              <Label>Empresa Importadora *</Label>
              <Select value={formData.importadora_id} onValueChange={(v) => setFormData({ ...formData, importadora_id: v })}>
                <SelectTrigger><SelectValue placeholder="Seleccionar" /></SelectTrigger>
                <SelectContent>
                  {importadoras.map(i => (
                    <SelectItem key={i.id} value={i.id}>{i.razon_social} - {i.rut}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Fecha Carga *</Label>
              <Input type="date" value={formData.load_date} onChange={(e) => setFormData({ ...formData, load_date: e.target.value })} required />
            </div>
            <div className="space-y-2">
              <Label>Fecha Entrega *</Label>
              <Input type="date" value={formData.delivery_date} onChange={(e) => setFormData({ ...formData, delivery_date: e.target.value })} required />
            </div>
            <div className="space-y-2">
              <Label>N° Despacho *</Label>
              <UpperCaseInput 
                value={formData.dispatch_number} 
                onChange={(e) => { 
                  setFormData({ ...formData, dispatch_number: e.target.value }); 
                  if (e.target.value) validateDispatchNumber(e.target.value); 
                }} 
                required 
                className={dispatchNumberError ? 'border-red-500' : ''} 
              />
              {dispatchNumberError && <p className="text-xs text-red-600">{dispatchNumberError}</p>}
            </div>
            <div className="space-y-2">
              <Label>N° CRT *</Label>
              <UpperCaseInput value={formData.crt_number} onChange={(e) => setFormData({ ...formData, crt_number: e.target.value })} required />
            </div>
            <div className="space-y-2">
              <Label>Valor Flete/Ton *</Label>
              <Input type="number" step="0.01" value={formData.freight_value_per_ton} onChange={(e) => setFormData({ ...formData, freight_value_per_ton: parseFloat(e.target.value) || 0 })} required />
            </div>
            <div className="space-y-2">
              <Label>Corredor *</Label>
              <Select value={formData.broker} onValueChange={(v) => setFormData({ ...formData, broker: v })}>
                <SelectTrigger><SelectValue placeholder="Seleccionar" /></SelectTrigger>
                <SelectContent>
                  {CORREDOR_OPTIONS.map(o => (<SelectItem key={o} value={o}>{o}</SelectItem>))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Cantidad de Camiones *</Label>
              <Input type="number" min="1" value={formData.truck_count} onChange={(e) => setFormData({ ...formData, truck_count: parseInt(e.target.value) || 1 })} required />
            </div>
            <div className="space-y-2">
              <Label>Estado</Label>
              <Select value={formData.status} onValueChange={(v) => setFormData({ ...formData, status: v })}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="En Proceso">En Proceso</SelectItem>
                  <SelectItem value="Pendiente">Pendiente</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <Button type="submit" className="w-full bg-primary hover:bg-primary-hover text-white" disabled={!!dispatchNumberError}>
            Crear Despacho
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default CreateDispatchModal;
